"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.array.map");

var _classCallCheck = require("/Users/therounds/Desktop/Philosocode.github.io/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/therounds/Desktop/Philosocode.github.io/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/Users/therounds/Desktop/Philosocode.github.io/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/therounds/Desktop/Philosocode.github.io/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/therounds/Desktop/Philosocode.github.io/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/therounds/Desktop/Philosocode.github.io/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Repulse = void 0;

var RepulseDiv_1 = require("./RepulseDiv");

var RepulseBase_1 = require("./RepulseBase");

var Repulse = /*#__PURE__*/function (_RepulseBase_1$Repuls) {
  _inherits(Repulse, _RepulseBase_1$Repuls);

  var _super = _createSuper(Repulse);

  function Repulse() {
    _classCallCheck(this, Repulse);

    return _super.apply(this, arguments);
  }

  _createClass(Repulse, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(Repulse.prototype), "load", this).call(this, data);

      if ((data === null || data === void 0 ? void 0 : data.divs) === undefined) {
        return;
      }

      if (data.divs instanceof Array) {
        this.divs = data.divs.map(function (s) {
          var tmp = new RepulseDiv_1.RepulseDiv();
          tmp.load(s);
          return tmp;
        });
      } else {
        if (this.divs instanceof Array || !this.divs) {
          this.divs = new RepulseDiv_1.RepulseDiv();
        }

        this.divs.load(data.divs);
      }
    }
  }]);

  return Repulse;
}(RepulseBase_1.RepulseBase);

exports.Repulse = Repulse;